export default __webpack_public_path__ + "static/media/Scope-4.aceadbda.png";